import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge has to be told about the custom font sizes in
 * tailwind.config.ts. Without this it reads `text-micro` as a *colour*, so
 * `cn("text-micro", "text-warn")` silently dropped the size and every chip
 * built that way rendered at body size.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["micro", "headline", "hero", "figure", "figure-lg"] }],
    },
  },
});

/** Merge Tailwind classes, letting later ones win conflicts. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
